/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_LOG_BATCH_FILTER_DATA = 'GET_LOG_BATCH_FILTER_DATA';
export const GET_CHECK_PAYEE_LIST = 'GET_CHECK_PAYEE_LIST';
export const GET_LOG_BATCH_TOTAL_LIST = 'GET_LOG_BATCH_TOTAL_LIST';
export const GET_LOG_BATCH_TOTAL_DETAIL = 'GET_LOG_BATCH_TOTAL_DETAIL';
export const GET_LOG_BATCH_TOTAL_HISTORY = 'GET_LOG_BATCH_TOTAL_HISTORY';
export const GET_LOG_NUMBER_DETAILS = 'GET_LOG_NUMBER_DETAILS';
export const SAVE_STATUS = 'SAVE_STATUS';
export const HANDLE_ERROR_MSG = 'HANDLE_ERROR_MSG';
export const DETAIL_SCREEN_OBJ = 'DETAIL_SCREEN_OBJ';
